import './App.css';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function App() {
  const [isLive, setIsLive] = useState(false);
  const [hoveredSection, setHoveredSection] = useState(null);
  const navigate = useNavigate();

  // Check if streaming on Twitch
  useEffect(() => {
    const checkTwitchStatus = async () => {
      try {
        // For now, this is a placeholder
        // To implement real live detection, you'll need:
        // 1. Register app at https://dev.twitch.tv/console/apps
        // 2. Get Client ID and OAuth token
        // 3. Make API call to check stream status
        setIsLive(false);
      } catch (error) {
        console.log('Could not fetch Twitch status');
        setIsLive(false);
      }
    };

    checkTwitchStatus();
    // Check every 2 minutes
    const interval = setInterval(checkTwitchStatus, 120000);
    return () => clearInterval(interval);
  }, []);

  const handleNavClick = (section) => {
    const actions = {
      'games': () => navigate('/games'),
      'stream': () => window.open('https://www.twitch.tv/sebbangeli', '_blank', 'noopener,noreferrer'),
      'standup': () => window.open('https://www.youtube.com/watch?v=ZhRLSx0uhIY', '_blank', 'noopener,noreferrer'),
      'youtube': () => window.open('https://www.youtube.com/@TheSebbangeli', '_blank', 'noopener,noreferrer'),
      'community': () => alert('Coming Soon! Stay tuned for updates.'),
      'contact': () => window.location.href = 'mailto:hello@nalkas.nu'
    };

    if (actions[section]) {
      actions[section]();
    }
  };

  return (
    <div className="App">
      {/* Top Navigation Bar */}
      <nav className="top-nav">
        <div 
          className={`nav-item ${hoveredSection === 'games' ? 'hovered' : ''}`}
          onMouseEnter={() => setHoveredSection('games')}
          onMouseLeave={() => setHoveredSection(null)}
          onClick={() => handleNavClick('games')}
        >
          Games/Stream
        </div>
        <div 
          className={`nav-item ${hoveredSection === 'standup' ? 'hovered' : ''}`}
          onMouseEnter={() => setHoveredSection('standup')}
          onMouseLeave={() => setHoveredSection(null)}
          onClick={() => handleNavClick('standup')}
        >
          Stand Up
        </div>
        <div 
          className={`nav-item ${hoveredSection === 'youtube' ? 'hovered' : ''}`}
          onMouseEnter={() => setHoveredSection('youtube')}
          onMouseLeave={() => setHoveredSection(null)}
          onClick={() => handleNavClick('youtube')}
        >
          YouTube
        </div>
        <div 
          className={`nav-item ${hoveredSection === 'community' ? 'hovered' : ''}`}
          onMouseEnter={() => setHoveredSection('community')}
          onMouseLeave={() => setHoveredSection(null)}
          onClick={() => handleNavClick('community')}
        >
          Community
        </div>
        <div 
          className={`nav-item ${hoveredSection === 'contact' ? 'hovered' : ''}`}
          onMouseEnter={() => setHoveredSection('contact')}
          onMouseLeave={() => setHoveredSection(null)}
          onClick={() => handleNavClick('contact')}
        >
          Contact
        </div>
      </nav>

      {/* Main Interactive Artwork */}
      <div className="artwork-container">
        <img src="/nalkas-artwork.png" alt="Nalkas Interactive" className="artwork-bg" />
        
        {/* Clickable Regions - positioned absolutely over the image */}
        
        {/* Games/Stream Section - Left Pink Area */}
        <div 
          className="clickable-region games-region"
          onClick={() => handleNavClick('games')}
          title="Games"
        />
        
        {/* Computer Screen - Twitch Embed */}
        <div className="computer-screen">
          {isLive ? (
            <div className="live-indicator">
              <span className="live-dot">🔴</span>
              <span className="live-text">LIVE</span>
            </div>
          ) : (
            <iframe
              src="https://player.twitch.tv/?channel=sebbangeli&parent=nalkas.nu&parent=www.nalkas.nu&parent=localhost&muted=true"
              frameBorder="0"
              allowFullScreen={true}
              scrolling="no"
              height="100%"
              width="100%"
              title="Twitch Stream"
            />
          )}
        </div>

        {/* Stand Up Section - Red Curtain */}
        <div 
          className="clickable-region standup-region curtain-animation"
          onClick={() => handleNavClick('standup')}
          title="Stand Up Comedy"
        />

        {/* YouTube Section - Brown Right Area with speech bubbles and sword/legs */}
        <div 
          className="clickable-region youtube-region"
          onClick={() => handleNavClick('youtube')}
          title="YouTube Channel"
        />

        {/* Community Section - Parachute guy and Discord cat */}
        <div 
          className="clickable-region community-region"
          onClick={() => handleNavClick('community')}
          title="Community (Coming Soon)"
        />

        {/* Contact Section - Star on right */}
        <div 
          className="clickable-region contact-region"
          onClick={() => handleNavClick('contact')}
          title="Contact"
        />
      </div>
    </div>
  );
}

export default App;
